import * as React from "react";

interface Props {
  children?: React.ReactNode;
}

/** The buttons on the end of a card's line. */
export const ItemActions: React.FC<Props> = ({ children }) => <>{children}</>;

type CardIconButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  /** What it does, for screen readers and the tooltip, since it's only an icon */
  label: string;
};

/** A small wood icon button on a card (notes, archive): quiet, but with a decent target. */
export const CardIconButton = React.forwardRef<HTMLButtonElement, CardIconButtonProps>(
  ({ label, children, className, ...rest }, ref) => (
    <button
      ref={ref}
      type="button"
      className={`icon-button ${className ?? ""}`}
      aria-label={label}
      title={label}
      {...rest}
    >
      {children}
    </button>
  ),
);
